import PortalVue from 'portal-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import studio from './modules/database/utils'
import { App } from 'vue'
import { hasFeature } from './featureFlags/featureFlags'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

export const setupVueEnv = (app: App) => {
  library.add(fab, far, fas)
  app.component('icon', FontAwesomeIcon)

  // app.config.productionTip = false
  // app.config.devtools = false

  app.config.globalProperties.$hasFeature = hasFeature

  if (process.env.NODE_ENV === 'test') {
    // This is a dynamic import. It will only be executed when `NODE_ENV` is 'test'.
    // This prevents `vitest` from being bundled in your production/development builds.
    import('vitest').then(({ vi, afterAll, afterEach }) => {
      // In the vue test environment, we want the modals to be shown inside the component. Else we cannot query them.
      // We cannot use the same approach as in the production environment, because the modals are not rendered op top
      // https://github.com/LinusBorg/portal-vue/issues/260
      // app.config.ignoredElements = ['portal']
      app.config.compilerOptions.isCustomElement = (tag) => tag === 'portal'
      afterEach(() => {
        if (studio.subscriptions.runningKeys().length > 0) {
          console.error('Running keys are still', studio.subscriptions.runningKeys())
          studio.subscriptions.runningKeys().forEach((key) => studio.subscriptions.unsubscribeFB(key))
        }
      })
      afterAll(() => {
        vi.restoreAllMocks()
        global.gc && global.gc()
      })
    }).catch(error => console.error('Failed to import vitest', error))
  } else {
    // In production they are showed in the App.vue component on top of everything
    app.use(PortalVue)
  }
}
